export const PENDING_ACTIONS = {
  checkUser: 'checkUser',
  loginPassword: 'loginPassword',
  sendLoginOtp: 'sendLoginOtp',
  submitLoginOtp: 'submitLoginOtp',
  join: 'join',
  submitSignUpOtp: 'submitSignUpOtp',
} as const

export type PendingAction = (typeof PENDING_ACTIONS)[keyof typeof PENDING_ACTIONS]
